import React from "react";
import Image from "next/image";
import { Box, Stack, VStack } from "@chakra-ui/react";
import Aicpa from "public/certificates/aicpa.webp";
import Gdpr from "public/certificates/gdpr.webp";
import Ccpa from "public/certificates/ccpa.webp";
import { SectionDivider } from "app/components/shared/SectionDivider";

export const CERTIFICATES = [
  {
    name: "aicpa",
    image: Aicpa,
    org_name: "American Institute of Certified Public Accountants",
    org_url: "https://www.aicpa-cima.com/",
    desc: "AICPA's CPA designation is a prestigious credential, signifying expertise in accounting, taxation, audit, and business law. Recognized indefinitely, it represents the highest standards in the field. For details, visit the official AICPA website.",
  },
  {
    name: "gdpr",
    image: Gdpr,
    org_name: "General Data Protection Regulation",
    org_url: "https://gdpr-info.eu/",
    desc: "The General Data Protection Regulation (GDPR) is a comprehensive privacy regulation governing data protection and privacy for individuals within the European Union. It aims to empower individuals and regulate how organizations handle personal data. For specifics, consult the official GDPR documentation.",
  },
  {
    name: "ccpa",
    image: Ccpa,
    org_name: "California Consumer Privacy Act",
    org_url: "https://oag.ca.gov/privacy/ccpa",
    desc: "The California Consumer Privacy Act (CCPA) grants California residents rights over their personal data. Effective since 2020, it provides control over data collection, disclosure, and ensures privacy rights. For details, refer to the official CCPA documentation.",
  },
];

const Certificates = () => {
  return (
    <VStack>
      <SectionDivider label="Your Data Is Always Secure" />
      <Stack
        borderRadius={"8px"}
        direction={{ base: "column", sm: "row" }}
        gap={6}
        data-cy="section-certifications"
      >
        {CERTIFICATES.map((certificate, idx) => {
          return (
            <Box
              borderColor={"black"}
              borderRadius={"8px"}
              border={"1px solid #ddd"}
              key={idx}
              p={4}
            >
              <Box
                height={{ base: "200px", sm: "150px", md: "200px" }}
                position="relative"
                width={{ base: "200px", sm: "150px", md: "200px" }}
              >
                <Image
                  alt={certificate.name}
                  title={certificate.name}
                  blurDataURL={
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epARQABAAA//w6wAAAAAElFTkSuQmCC"
                  }
                  fill
                  placeholder="blur"
                  src={certificate.image}
                  sizes={"(max-width: 200px) 100vw, 200px"}
                  style={{ objectFit: "contain" }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </VStack>
  );
};

export default Certificates;
